// extracted by mini-css-extract-plugin
module.exports =  {"common-link-error":"saveFile__common-link-error","error-left":"saveFile__error-left","error-right":"saveFile__error-right","error-classic":"saveFile__error-classic"};